import { CheckCircle2, Circle } from "lucide-react";

/**
 * Shows what AivoryONE / the operator has already completed vs remaining for an event.
 */
export default function SetupProgressPanel({ progress }) {
  if (!progress) return null;
  const completed = progress.completed || [];
  const remaining = progress.remaining || [];
  const summary = progress.summary || {};
  const title = progress.eventTitle;
  if (!completed.length && !remaining.length) return null;

  return (
    <div
      className="rounded-xl border border-[var(--border-default)] bg-[var(--bg-elev)] p-3 mb-3"
      data-testid="setup-progress-panel"
    >
      <div className="flex items-center justify-between gap-2 mb-2">
        <p className="text-[10px] font-mono uppercase tracking-wider text-[var(--text-tertiary)]">
          {title ? `Setup · ${title}` : "Setup progress"}
        </p>
        <span className="text-[10px] font-mono text-[var(--text-tertiary)]">
          {summary.done ?? completed.length}/{summary.total ?? completed.length + remaining.length}
          {typeof summary.pct === "number" ? ` · ${summary.pct}%` : ""}
        </span>
      </div>
      {completed.length ? (
        <div className="mb-2">
          <p className="text-[10px] text-emerald-600 mb-1">Completed</p>
          <ul className="space-y-1">
            {completed.map((item) => (
              <li key={item.id || item.label} className="flex items-start gap-2 text-xs text-[var(--text-secondary)]">
                <CheckCircle2 size={14} className="shrink-0 mt-0.5 text-emerald-600" />
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
      {remaining.length ? (
        <div>
          <p className="text-[10px] text-[var(--text-tertiary)] mb-1">Still to do</p>
          <ul className="space-y-1">
            {remaining.map((item) => (
              <li key={item.id || item.label} className="flex items-start gap-2 text-xs text-[var(--text-primary)]">
                <Circle size={14} className="shrink-0 mt-0.5 text-[var(--text-tertiary)]" />
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="text-xs text-emerald-600">All checklist items complete.</p>
      )}
    </div>
  );
}
